{{if data && data.length  > 0}}
	{{each data v idx}}
	<p>获得了以下礼品：<span style="margin-right:10px;">{{v.name}}</span></p>
	{{/each}} 
{{else}}
	很遗憾 没有得到礼品  
{{/if}}




// WEBPACK FOOTER //
// /usr/local/src/vipp-cli/web_modules/component/hdplatform/giftEx/exchangegift.tpl